import React from "react";
import {
  View,
  Text,
  ImageBackground,
  Pressable,
  ScrollView,
  Platform,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { useNavigation } from "@react-navigation/native";

import styles from "../styles/profileStyle";
import dimensions from "../../../globalStyles/dimensions";
import CustomComponent from "../../../components/CustomComponent";
import GlobalStyles from "../../../globalStyles/globalStyles";
import { Colors } from "../../../globalStyles/ColorConfig";
import { PROFILE_ROUTES } from "../../../navigation/routes";
import ProfileIcons from "../../../assets/Icons/FeedIcons/ProfileIcons";
import AuthIcons from "../../../assets/Icons/AuthIcons";

const SubscribeOnboarding = () => {
  const navigation = useNavigation();

  return (
    <>
      <ScrollView
        contentContainerStyle={{
          backgroundColor: "black",
        }}
      >
        <View style={styles.subscribeTop}>
          <ImageBackground
            source={{
              uri: "https://hushl-spark-dev.s3.ap-south-1.amazonaws.com/frontend-assets/onboarding/subscribe.webp",
            }}
            resizeMode="cover"
            style={{
              height: "100%",
              width: "100%",
            }}
          >
            <View
              style={{
                position: "absolute",
                left: 0,
                right: 0,
                alignItems: "center",
              }}
            >
              <View
                style={{
                  top: dimensions.windowHeight / 4,
                }}
              >
                <AuthIcons.LogoText />
              </View>
              <CustomComponent.TextView
                title="Subscribe go on twice as many dates."
                textStyle={[
                  GlobalStyles.heading3,
                  { color: Colors.white000, textAlign: "center" },
                ]}
                boxStyle={{
                  position: "absolute",
                  top: dimensions.windowHeight / 2.6,
                  //   width: dimensions.windowWidth / 1.4,
                  width: Platform.OS === "web" ? 390 : dimensions.windowWidth,
                  zIndex: 2,
                }}
              />
            </View>
            <LinearGradient
              colors={["transparent", Colors.black100]}
              style={{
                position: "absolute",
                width: "100%",
                height: dimensions.windowHeight / 4,
                bottom: 0,
              }}
            />
          </ImageBackground>
        </View>

        <View style={styles.subscribeMid}>
          <View>
            <View style={styles.selectConponent}>
              <Text style={[GlobalStyles.bodyText, { color: "#fff" }]}>
                Skip the Waitlist
              </Text>
              <View style={styles.selectConponentCircle}>
                <ProfileIcons.TickGoldIcon />
              </View>
            </View>
            <View style={styles.selectConponent}>
              <Text style={[GlobalStyles.bodyText, { color: "#fff" }]}>
                Unlimited likes
              </Text>
              <View style={styles.selectConponentCircle}>
                <ProfileIcons.TickGoldIcon />
              </View>
            </View>
            <View style={styles.selectConponent}>
              <Text style={[GlobalStyles.bodyText, { color: "#fff" }]}>
                Enhanced recommendations
              </Text>
              <View style={styles.selectConponentCircle}>
                <ProfileIcons.TickGoldIcon />
              </View>
            </View>
            <View style={styles.selectConponent}>
              <Text style={[GlobalStyles.bodyText, { color: "#fff" }]}>
                Direct message
              </Text>
              <View style={styles.selectConponentCircle}>
                <ProfileIcons.TickGoldIcon />
              </View>
            </View>
            <View style={styles.selectConponent}>
              <Text style={[GlobalStyles.bodyText, { color: "#fff" }]}>
                See who likes you
              </Text>
              <View style={styles.selectConponentCircle}>
                <ProfileIcons.TickGoldIcon />
              </View>
            </View>
          </View>
          <CustomComponent.TextView
            title="and more..."
            textStyle={[
              GlobalStyles.bodyText,
              { color: Colors.white10, opacity: 0.6 },
            ]}
            boxStyle={{
              paddingVertical: dimensions.paddingVertical / 2,
              paddingHorizontal: dimensions.paddingHorizontal / 3,
            }}
          />
        </View>
      </ScrollView>
      <View
        style={{
          position: "absolute",
          width: Platform.OS === "web" ? 390 : dimensions.windowWidth,
          height: dimensions.windowHeight / 5,
          backgroundColor: Colors.black100,
          bottom: 0,
          paddingHorizontal: 20,
          justifyContent: "space-evenly",
        }}
      >
        <CustomComponent.AppBtn
          name={"Check it out"}
          style={{
            backgroundColor: Colors.green10,
            justifyContent: "center",
            borderRadius: 68,
            paddingVertical: 26,
          }}
          textStyle={[GlobalStyles.bodyText, { color: Colors.white10 }]}
          onPress={() => {
            navigation.navigate(PROFILE_ROUTES.ONBOARD_ALLDONE as never);
          }}
        />
        <Pressable
          onPress={() =>
            navigation.navigate(PROFILE_ROUTES.ONBOARD_ALLDONE as never)
          }
        >
          <CustomComponent.TextView
            title="Maybe later"
            textStyle={[
              GlobalStyles.bodyText,
              { color: Colors.white000, textAlign: "center" },
            ]}
          />
        </Pressable>
      </View>
    </>
  );
};

export default SubscribeOnboarding;
